module.exports = __webpack_public_path__ + "static/Car-28ca9a2e0fa61cfe7784510f0c589409.jpg";